exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_wks-ext.js
// module id = 375
// module chunks = 2